module.exports = __webpack_public_path__ + "static/media/medical.4afc3715.jpg";